/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectResult } from '../../models/object-result';
import { UpsertUserCommand } from '../../models/upsert-user-command';

export interface ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params {
      body?: UpsertUserCommand
}

export function apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal(http: HttpClient, rootUrl: string, params?: ApiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<ObjectResult>> {
  const rb = new RequestBuilder(rootUrl, apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=minimal;odata.streaming=true');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=minimal', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ObjectResult>;
    })
  );
}

apiUserPost$JsonOdataMetadataMinimalOdataStreamingTrue$JsonOdataMetadataMinimal.PATH = '/api/user';
